import {Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import { Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { MetadataService } from 'src/app/core/services/metadata.service';
import { SecureStorageService } from 'src/app/core/services/secure-storage.service';

@Component({ standalone: false,
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',

  styleUrls: ['./content-layout.component.css']
})
export class ContentLayoutComponent implements OnInit  {

  loginDisplay = false;
  menus: any = [];
  noMenus = false;

  constructor(
    public secureStorageService: SecureStorageService,
    private authService: AuthService,
    private msalService: MsalService, private msalBroadcastService: MsalBroadcastService,
    private metadataService: MetadataService,
    private loadingService: LoadingService,
    private routerParam: Router,
    private cdr: ChangeDetectorRef
  ){
    this.menus = this.secureStorageService.getData("menus") ? JSON.parse(this.secureStorageService.getData("menus") ?? "[]") : []
  }

  ngOnInit(): void {
    

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      })
  }

  async ejecutarConRetraso() {
    this.metadataService.getMenu().subscribe({
      next: (data: any) => {
        if(data){
          this.secureStorageService.saveData('menus', JSON.stringify(data.Menus));
          this.secureStorageService.saveData('acciones', JSON.stringify(data.Actions));
          this.secureStorageService.saveData('parametros', JSON.stringify(data.Parameters));
          this.menus = data.Menus;
          if(this.menus.length === 0){
            this.noMenus = true;
          }
        }
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Error al obtener el menú:', err);
        this.cdr.detectChanges();
      }
    });
  }

  CerrarSesion(){
    this.authService.microsoftLogout();
  }
  
  setLoginDisplay() {

    this.loginDisplay = this.msalService.instance.getAllAccounts().length > 0;

    if(this.loginDisplay){
      
      const dataMenus = this.secureStorageService.getData("menus") ? JSON.parse(this.secureStorageService.getData("menus") ?? "[]") : []
      
      if(dataMenus.length === 0){
        this.ejecutarConRetraso();
      }else{
        this.menus = dataMenus;
      }

    }
    this.cdr.detectChanges();
  }

  onSubmit(): void {
    this.authService.microsoftLogin();
  }

}
